import { render } from "./GoogleAuthSuccess.vue?vue&type=template&id=9db7d056"
import script from "./GoogleAuthSuccess.vue?vue&type=script&lang=js"
export * from "./GoogleAuthSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__